<template>
  <svg fill="none" height="18" viewBox="0 0 18 18" width="18">
    <path
      d="M1.24 4.95096L9 8.97528L16.76 4.95096M9 17V8.96731M17 12.1549V5.77973C16.9997 5.50024 16.9174 5.22574 16.7614 4.98376C16.6054 4.74179 16.3811 4.54085 16.1111 4.4011L9.88889 1.21353C9.61863 1.07364 9.31207 1 9 1C8.68793 1 8.38137 1.07364 8.11111 1.21353L1.88889 4.4011C1.6189 4.54085 1.39465 4.74179 1.23863 4.98376C1.08262 5.22574 1.00032 5.50024 1 5.77973V12.1549C1.00032 12.4344 1.08262 12.7089 1.23863 12.9509C1.39465 13.1928 1.6189 13.3938 1.88889 13.5335L8.11111 16.7211C8.38137 16.861 8.68793 16.9346 9 16.9346C9.31207 16.9346 9.61863 16.861 9.88889 16.7211L16.1111 13.5335C16.3811 13.3938 16.6054 13.1928 16.7614 12.9509C16.9174 12.7089 16.9997 12.4344 17 12.1549Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>

<script>
  export default {
    name: 'ProductsIcon',
  };
</script>
